<template>
    <div>
        <span v-if="!isLoading">
            <a @click.stop="downloadRiskStudents(doyang.id)">Riesgos de bajas:</a>
            <span>{{ doyang.risk_students_count || 0 }}</span>
        </span>
        <!--Spinning wheel-->
        <span v-else>
            Cargando riesgo de bajas...
        </span>
    </div>
</template>

<script>
export default {
    data() {
        return {
            message: "This is the Active Students Text component.",
            isLoading: false,
        };
    },
    methods: {
        downloadRiskStudents(doyangId) {
            this.isLoading = true
            this.$store.dispatch("Doyang/show", `${doyangId}/risk_students`).then((response) => {
                this.downloadStringInNewPage(response, 'alumnos_en_riesgo.csv')
            }).then(() => {
                this.isLoading = false
            })
        },
        downloadStringInNewPage(string, filename) {
            const blob = new Blob([string], { type: 'text/csv' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.setAttribute('hidden', '');
            a.setAttribute('href', url);
            a.setAttribute('download', filename);
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        },
    },
    props: {
        doyang: {
            type: Object,
            required: true
        }
    }
};
</script>

<style scoped>
h1 {
    color: blue;
}

p {
    font-size: 18px;
}
</style>